{
  "ACTIONS": {
    "CONFIRM": "تأكيد",
    "CONTINUE": "متابعة",
    "SUBMIT": "حفظ",
    "RETRY": "إعادة المحاولة",
    "CANCEL": "إلغاء",
    "EMPTY": "لا يوجد لديك طلبات",
    "LOADING_ORDERS": "جاري تحميل فاتورتك ",
    "CLEAR_ALL": "مسح الخيارات",
    "AWESOME": "رائع",
    "VIEW_RECEIPT": "الفاتورة",
    "ADD_CART": "أضف إلى السلة",
    "UPDATE_CART": "تحديث السلة",
    "EDIT": "تعديل",
    "SEARCH_PLACEHOLDER": "ابحث عن أكلات أو مطاعم"
  },
  "COMMON": {
    "CALORIES": "{{calories}} سعرة حرارية",
    "MISSING_SELECTIONS": "يرجى إكمال تعبئة الخيارات قبل المتابعة",
    "ITEM_UNAVAILABLE": "عذراً، هذا المنتج غير متوفر حالياً",
    "SECTION_NOT_FOUND": "عذراً، هذا القسم لم يعد متوفراً",
    "ITEM_NOT_FOUND": "عذراً، هذا المنتج لم يعد متوفراً",
    "PROMOTION_NOT_AVAILABLE": "عذراً، هذا العرض لم يعد متوفراً",
    "REQUIRED": "إلزامي",
    "COMBO": "كومبو",
    "INVALID_EMAIL": "يرجى إدخال بريد إلكتروني صحيح",
    "INVALID_PHONE": "يرجى إدخال رقم هاتف صحيح",
    "FEES": "الرسوم الاضافية",
    "MIN_ORDER_ERROR": "عليك الوصول لقيمة الحد الأدنى {{currency}} {{amount}} للطلب ",
    "ADD_MIN_ORDER": "أضف {{amount}} {{currency}} كي تستطيع أن تتقدم بالطلب",
    "CONNECTION_ERROR": "حدث خطأ أثناء تحميل هذه الطاولة. يرجى المحاولة مرة أخرى.",
    "TABLE_NOT_FOUND": "لم نتمكن من العثور على هذه الطاولة. يرجى إعادة مسح رمز QR."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "اسم العائلة",
    "ROOM_NUMBER": "رقم الغرفة",
    "SNACKBAR_TITLE": "سنكون معك قريباً",
    "PAY_BILL": "ادفع فاتورة"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "عدد الأشخاص على الطاولة",
    "PAYING_FOR": "عدد الأشخاص الذين ستدفع عنهم",
    "REMAINING": "المبلغ المتبقي",
    "CHEQUE": "الفاتورة",
    "AMOUNT_PAID": "المبلغ المدفوع",
    "DISCOUNT": "الخصم",
    "PROMO": "برومو",
    "FEES": "الرسوم",
    "PAID_ITEMS": "الأصناف المدفوعة",
    "SPLIT_BILL": "قسّم الفاتورة",
    "EDIT_SPLIT": "تعديل التقسيم",
    "PAY_BILL": "ادفع الفاتورة",
    "SPLIT_TITLE": "تقسيم الفاتورة",
    "SPLIT_SUBTITLE": "اختر طريقة تقسيم الفاتورة",
    "SPLIT_EVENLY": "تقسيم بالتساوي",
    "CUSTOM_AMOUNT": "مبلغ مخصص",
    "ADD_CUSTOM_AMOUNT": "أضف مبلغًا مخصصًا",
    "CUSTOM_AMOUNT_PLACEHOLDER": "أدخل مبلغًا مخصصًا",
    "PAY_FOR_ITEMS": "ادفع طلباتك او ادفع عن أصنافك",
    "CONFIRM_SELECTION": "تأكيد الاختيار",
    "SOMEONE_ELSE_PAYING": "شخص آخر على طاولتك يقوم بالدفع الآن"
  },
  "COMBO": {
    "ADD_N": "أضف {{count}} {{section}}",
    "REMOVE_N": "احذف {{count}} {{section}}",
    "CANNOT_PROCEED": "يرجى اتباع الإرشادات أعلاه لإكمال الكومبو قبل المتابعة",
    "COMPLETE": "اكتمل كومبو {{combo}}!",
    "ON_ANOTHER_SECTION": "هذا جزء من كومبو {{section}} الخاص بك"
  },
  "CART": {
    "TITLE": "بطاقة",
    "RECOMMENDATION": "قد يعجبك أيضاً",
    "TOTAL": "المجموع",
    "VIEW": "عرض السلة والتقدم بالطلب",
    "EMPTY": "فارغة",
    "PLACE_ORDER": "تقدم بطلب",
    "ADD_TO_BILL": "أضف إلى الفاتورة",
    "PAY_NOW": "ادفع الآن",
    "OOPS": "يا ساتر",
    "ADD_NEW_VARIANT": "أضف آخر",
    "VARIANT_TITLE": "غيّرت رأيك؟",
    "ITEM_UPDATED": "تم تحديث منتج في سلتك",
    "ITEM_REMOVED": "تمت إزالة منتج من سلتك لأنه لم يعد متوفراً",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "هل أنت متأكد؟",
    "CLEAR": "مسح السلة",
    "ADD_NOTE": "أضف ملاحظة",
    "NOTE_LABEL": "ملاحظة"
  },
  "PAYMENT": {
    "CONFIRMED": "تم دفع فاتورة الطلب بنجاح",
    "ERROR": "حصل خطأ خلال عملية الدفع، يرجى المحاولة مرة أخرى",
    "APPLE_PAY_TAP_AGAIN": "يرجى الضغط على Apple Pay مرة أخرى للمتابعة",
    "TITLE": "الدفع",
    "PAY_CARD": "إدفع",
    "SUCCESSFUL": "تم دفع الفاتورة بنجاح",
    "SUMMARY": "الفاتورة",
    "PROGRESS": "الرجاء الانتظار حتى تتم عملية الدفع...",
    "CANCEL": "الرجاء عدم إعادة تحميل الصفحة أو الرجوع. إن أردت أن تلغي العملية، يرجى الضغط على زر الالغاء الموجود على ماكينات الدفع."
  },
  "ORDER": {
    "TITLE": "طلباتي",
    "CONFIRMED": "تم",
    "NOTES": "أضف ملاحظات",
    "TOTAL": "المجموع",
    "SUBTOTAL": "المجموع الفرعي",
    "ORDER": "طلب",
    "PAID": "مدفوع",
    "PLACED": "طلبك قد وضع بنجاح",
    "UNPAID": "طلبك لم يتم دفعه",
    "CANCELLED": "تم إلغاء طلبك",
    "VOID": "تم إبطال طلبك",
    "UPDATED": "تم تحديث طلبك",
    "ORDERS": "طلبات",
    "PREVIOUS": "الطلبات السابقة",
    "REJECTED": "عذراً، بعض الصحون التي تود طلبها غير موجودة حالياً وسيتم الغائها من الطلبية"
  },
  "WAITER": {
    "SNACKBAR_TITLE": "سنكون معك قريباً",
    "HELP": "كيف يمكن ان نساعد؟",
    "ADDITIONAL_COMMENTS": "ملاحظات"
  },
  "MENU": {
    "SKIP": "تخطي",
    "MENU": "القائمة",
    "SEARCH": "بحث",
    "NO_SEARCH_RESULTS": "لا توجد عناصر مطابقة لبحثك",
    "SEARCH_OTHER_SECTIONS": "وجدنا نتائج مطابقة في أقسام أخرى",
    "NO_FILTER_RESULTS": "لا توجد عناصر مطابقة للفلاتر المحددة",
    "CLEAR_FILTERS": "مسح الفلاتر",
    "NO_SECTIONS": "لا توجد أقسام متاحة",
    "STAFF": "نادل",
    "FILTERS": "التصفيات الغذائية"
  },
  "SETTINGS": {
    "TITLE": "الإعدادات",
    "LANGUAGE": "اللغة",
    "SELECT_LANGUAGE": "اختر اللغة",
    "CURRENCY": "العملة"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "أضف لحساب الغرفة"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "QR يرجى إعادة مسح اللمواصلة جلستك",
    "SESSION_EXPIRED": "انتهت صلاحية جلستك"
  },
  "PICKUP": {
    "TITLE": "تفاصيلك"
  },
  "VOUCHER": {
    "ADD": "أضف قسيمة خصم",
    "PLACEHOLDER": "أدخل رمز القسيمة",
    "VOUCHER": "الخصم",
    "DISCOUNTED_AMOUNT": "المجموع بعد الخصم",
    "CURRENT_BALANCE": "الرصيد الحالي",
    "REMAINING_BALANCE": "الرصيد المتبقي",
    "AMOUNT_DUE": "المجموع المستحق"
  },
  "TIP": {
    "TIP": "إكرامية",
    "ADD": "أضف إكرامية",
    "PLACEHOLDER": "أدخل مبلغ الإكرامية"
  },
  "LANDING": {
    "CALL_WAITER": "استدعاء النادل",
    "VIEW_BILL": "انظر الفاتورة - ",
    "LOADING_BILL": "جاري تحميل الفاتورة"
  },
  "LOADER": {
    "Heading": "جاري معالجة دفعتك ...",
    "Subheading": "يرجى عدم إغلاق هذه الصفحة. نحن نقوم بتأكيد عملية الدفع وسيتم تحويلك تلقائيًا.",
    "Hint": "يستغرق ذلك عادةً بضع ثوانٍ."
  },
  "NoVoucher": "القسيمة غير متوفرة",
  "VoucherDisabled": "هذه القسيمة معطّلة",
  "VoucherExpired": "انتهت صلاحية هذه القسيمة",
  "VoucherAlreadyUsed": "تم استخدام هذه القسيمة من قبل",
  "VoucherZeroBalance": "رصيد هذه القسيمة هو 0",
  "VoucherUserLimitReached": "لقد استخدمت هذه القسيمة من قبل",
  "VoucherFirstOrderOnly": "هذه القسيمة لطلبك الأول فقط",
  "VoucherNotApplicable": "لا تنطبق هذه القسيمة على العناصر في طلبك"
}
